import {FC, PropsWithChildren} from "react";

import {Toaster} from "@/components/ui/toaster";
import {TooltipProvider} from "@/components/ui/tooltip";

const AppProvider: FC<PropsWithChildren> = ({children}) => {
  return (
    <TooltipProvider>
      {children}
      <Toaster />
    </TooltipProvider>
  );
};

export default AppProvider;
